import React, { FC, useContext, useMemo, useState } from "react";
import { twMerge } from "tailwind-merge";

import { ModalProps } from "./types";
import Icon from "../common/icon/Icon";
import { BaseModal } from "../common";
import { SCROLLBAR_CLASSES_BLACK } from "../../styles/commonClasses";

import AnimatedIcon1 from "../../assets/icons/loading-spinner-gradient.svg";

interface IAwaitingModalProps extends ModalProps {
  mainText?: string;
  secondaryText?: string;
};

export const AwaitingModal: FC<IAwaitingModalProps> = ({
  visible,
  hideModal,
  mainText,
  secondaryText,
}) => (
  <BaseModal
    open={visible}
    onClose={hideModal}
    classes={{
      dialog: `w-[342px] sm:max-w-[400px] bg-gray-800 p-5`
    }}
    withHeading={false}
  >
    <div
      data-id="awaiting-modal"
      className="flex flex-col gap-3 sm:gap-5 items-center max-h-[70vh] relative"
    >
      <div
        className={twMerge(
          "flex flex-col overflow-y-auto w-full pr-3 -mr-3 gap-y-5",
          SCROLLBAR_CLASSES_BLACK
        )}
      >
        <div className="flex w-full flex-col items-center font-normal gap-y-1.5">
          <Icon icon={<AnimatedIcon1 />} size="xxxl" className="mb-6" />
          {
            mainText
            && (<div className="flex font-semibold">{mainText}</div>)
          }
          {
            secondaryText
            && (<div className="flex text-gray-300">{secondaryText}</div>)
          }
        </div>
      </div>
    </div>
  </BaseModal>
);
